import cuid from "cuid";
import { defaults, get, keyBy, map } from "lodash";
import { useState } from "react";
import {
  CASE_TYPES,
  CONTACT_POINT_SYSTEM,
  PROFILE_LIST,
  SOCIAL_REGIMES,
} from "utils/constants";
import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const AdherentBirthDate = ({
  project,
  onNext,
  onBack,
  currentStatus,
  tracer,
}) => {
  const DEFAULT_DELTA_START = 1;
  const DEFAULT_DELTA_START_RIA = 40;
  const DEFAULT_DELTA_END_RIA = 0;
  const DEFAULT_DELTA_END = 0;
  const [deltas, setDeltas] = useState({
    start: { normal: DEFAULT_DELTA_START, ria: DEFAULT_DELTA_START_RIA },
    end: { normal: DEFAULT_DELTA_END, ria: DEFAULT_DELTA_END_RIA },
  });

  const onSubmit = ({ project: projectData, telecoms }) => {
    const updatedTelecoms = map(telecoms, (item, key) =>
      defaults(
        { ...item, value: item?.value != null ? String(item.value) : null },
        { id: cuid(), system: key },
      ),
    );

    onNext({
      payload: {
        ria: get(projectData, "ria") || false,
        contract: {
          id: cuid(),
          ...get(project, "contract"),
          ...get(projectData, "contract"),
          caseType: get(projectData, "ria")
            ? CASE_TYPES.RETURN_TO_COMPETITION
            : CASE_TYPES.NEW_CONTRACT,
        },
        contact: {
          id: cuid(),
          ...get(projectData, "contact", {}),
          fields: {
            ...get(project, "contact.fields", {}),
            ...get(projectData, "contact.fields", {}),
            profile: PROFILE_LIST.PARTICULAR,
          },
          user: {
            id: cuid(),
            ...get(project, "contact.user", {}),
            ...get(projectData, "contact.user", {}),
          },
          telecoms: updatedTelecoms,
        },
        terminationRequest: {
          id: cuid(),
          ...get(project, "terminationRequest"),
          ...get(projectData, "terminationRequest"),
        },
        fields: {
          ...get(project, "fields"),
          ...get(projectData, "fields"),
        },
      },
    });
  };

  const telecomsObject = defaults(
    keyBy(get(project, "contact.telecoms", []), "system"),
    {
      [CONTACT_POINT_SYSTEM.ZIP_CODE]: { value: null },
    },
  );

  const initialValues = {
    project: {
      ...project,
      contact: {
        socialRegime: SOCIAL_REGIMES.SECURITE_SOCIALE,
        ...get(project, "contact", {}),
      },
    },
    telecoms: telecomsObject,
  };

  return (
    <>
      <Navbar
        project={project}
        progress={currentStatus?.progress}
        step={1}
        stepCount={5}
        title="Faisons connaissance"
        showHelp={false}
      />
      <View
        initialValues={initialValues}
        onNext={onSubmit}
        onBack={onBack}
        tracer={tracer}
        locked={project?.locked}
        deltas={deltas}
      />
    </>
  );
};

export default AdherentBirthDate;
